import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse} from '@angular/common/http';
import {delay, first, firstValueFrom, Observable, Subject, tap} from 'rxjs';
import {Inject, Injectable} from "@angular/core";
import {filter, map} from "rxjs/operators";
import {klientUtdatertEvent} from "felles/infrastruktur/ApiVersjonResponsHeadereInterceptor";
import {ajs_$rootScope_DI_TOKEN, AjsRootScopeService} from "web-ng2/tjenester/ajs/AjsRootScopeService";
import {initDebugger} from "../../støttefunksjoner/debug";

const debug = initDebugger('ApiVersjonResponsHeadereHttpInterceptor');

/**
 * Leser api-versjon headere fra respons og broadcaster event dersom klient er utdatert.
 *
 * Se no.systemfabrikken.lederplan.infrastruktur.filter.ApiVersjonsnummerFilter for server-siden
 * som setter info om utdatert klient i responser.
 */
@Injectable()
export class ApiVersjonResponsHeadereHttpInterceptor implements HttpInterceptor {

    readonly klientUtdatert = new Subject<HttpEvent<any>>();

    constructor(@Inject(ajs_$rootScope_DI_TOKEN) private $rootScope: AjsRootScopeService) {
        this.broadcastAjsVedKlientUtdatert();
    }

    public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(req)
          .pipe(tap(respons => this.klientUtdatert.next(respons)));
    }

    private vedKlientUtdatert(): Promise<string> {
        return firstValueFrom(this.klientUtdatert.pipe(
          filter(event => event instanceof HttpResponse),
          filter((respons: HttpResponse<any>) =>
            //serveren forteller oss at klienten er utdatert
            respons.headers.get('X-lpKlientUtdatert') === 'true' &&
            //ignorer X-lpKlientUtdatert dersom respons skal caches
            !(respons.headers.getAll('Cache-Control') ?? []).includes('no-store')
          ),
          //trenger bare å bli informert om første req der X-lpKlientUtdatert==true
          first(),
          //la strømmen returnere api-ver server publiserer
          map((respons: HttpResponse<any>) => respons.headers.get('X-lpApiVer') ?? 'X-lpApiVer ikke angitt'),
          tap(lpApiVer=> debug('klient utdatert (lpApiVer: %s), broadcaster event "httpProvider:klientUtdatertEvent"', lpApiVer)),
          //vent i tre minutter før vi fyrer av 'klient utdatert' slik alle serer-instanser har rukket å bli oppdatert
          //i vårt rullende oppdaterings-regime
          delay(1000 * 60 * 3) //3 minutter (i millis)
        ));
    }

    private broadcastAjsVedKlientUtdatert() {
        this.vedKlientUtdatert().then(nyVersjon =>
          //må kjøres i $applyAsync for at ajs skal fange opp endringer
          this.$rootScope.$applyAsync(() => this.$rootScope.$broadcast(klientUtdatertEvent)));
    }
}
